import { toast } from 'bulma-toast'

type ToastType = 'is-danger' | 'is-warning' | 'is-info' | 'is-link'

export const showToast = (
  type: ToastType,
  message: string = 'Something happened.'
) => {
  toast({
    message,
    type,
    position: 'bottom-right',
    duration: 3000,
    dismissible: true,
  })
}

export const toastError = (message?: string) =>
  showToast('is-danger', message || 'Oh no, something went wrong. Please try again.');

export const toastSuccess = (message: string) =>
  showToast('is-link', message)

// export const toastInfo = (message?: string) =>
//   showToast('is-info', message || 'Just so you know.');

// export const toastWarning = (message?: string) =>
//   showToast('is-warning', message || 'Heads up!');